import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 10v2a7 7 0 01-7 7m-7-9v2a7 7 0 007 7m0 0v3m-4 0h8m-4-7a3 3 0 01-3-3V5a3 3 0 116 0v7a3 3 0 01-3 3z"
    })
  ]))
}